import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import uploadDocumentService from '@/services/document/uploadDocumentService';
import { useNavigate, useParams } from 'react-router-dom';

const CrmAuthRedirect = () => {
    const { token } = useParams();
    const navigate = useNavigate()
    const [successMessage, setSuccessMessage] = useState(false)
    const [errorMessage, setErrorMessage] = useState(false)

    useEffect(() => {
        if (token) {
            (async () => {
                try {
                    await uploadDocumentService.verifyDocUploadToken(token);
                } catch (error) {
                    if (error.message === "Invalid or expired token") {
                        toast.error('Invalid or expired Link.', {
                            description: 'Your Link has been expired. Please request again to get a new link.',
                        });
                        setErrorMessage(true)
                        return
                    }
                }
            })();
        }
    }, [token]);

    return (
        <>
            {successMessage ? (
                <div className='w-full max-w-[500px] min-w-[480px] text-center border-2 border-dashed my-5 p-5 h-[150px] flex items-center justify-center flex-col text-sm rounded-md transition border-success bg-success-light'>
                    <p className='text-xl font-medium text-success-active'>Documents uploaded successfully!</p>
                    <p className='mt-1 text-xs'>Your documents are now in the processing queue. <br /> You may close this window.</p>
                </div>
            ) : errorMessage ? (
                <div className="w-full max-w-[500px] min-w-[480px] text-center border-2 border-dashed my-5 p-5 h-[150px] flex items-center justify-center flex-col text-sm rounded-md transition border-danger bg-danger-light">
                    <p className='text-xl font-medium text-danger-active'>Invalid or expired Link Used!</p>
                    <p className='mt-1 text-xs'>Please request again to get a new link. <br /> You may close this window.</p>
                </div>
            ) : null}
        </>
    );

};

export { CrmAuthRedirect };
